import { ClipboardModule } from "@angular/cdk/clipboard";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { MatTooltipModule } from "@angular/material/tooltip";
import { MatDialogModule } from "@angular/material/dialog";
import { MatSliderModule } from "@angular/material/slider";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatSelectModule } from "@angular/material/select";
import { MatSlideToggleModule } from "@angular/material/slide-toggle";
import { AppDoubleMatSlideToggleModule, CoreModule } from "@youm-front/core";
import { UiSvgModule } from "@youm-front/ui-svg";
import { YoumAngularLibModule } from "@youm-front/youm-angular-lib";
import { SettingsComponent } from "./components";

@NgModule({
  imports: [
    CommonModule,
    ClipboardModule,
    MatTooltipModule,
    MatDialogModule,
    MatSliderModule,
    MatFormFieldModule,
    MatSelectModule,
    MatSlideToggleModule,
    AppDoubleMatSlideToggleModule,
    CoreModule,
    UiSvgModule,
    YoumAngularLibModule
  ],
  declarations: [SettingsComponent],
  exports: [SettingsComponent]
})
export class SettingsFeatureSettingsModule {}
